import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import OurClientForm from "./OurClientForm";

export default function EditOurClient({ name }) {
    return (
        <CustomCard title={name}>
            <OurClientForm type="EDIT" />
        </CustomCard>
    );
}
